import {MassOffersFormField} from "../types/blogger-mass-offer-modal.types";

export const bloggerMassOfferModalName = 'blogger-mass-offer';

export const massOffersFormFields: Array<MassOffersFormField> = [
  {
    label: 'Продукт',
    fieldName: 'productId',
    type: 'select'
  },
  {
    label: 'Введите сообщение',
    fieldName: 'message',
    type: 'textarea'
  }
]
